import { Injectable } from "@angular/core";
import { BeamConfigurationRequestDTO } from '../DTOs/request/beam-configuration-request-dto';
import { BeamIndentification } from '../interfaces/beam-indentification';
import { CoverageLevel } from '../interfaces/coverage-level';
import { CoverageLevelConfigurationRequestDTO } from '../DTOs/request/coverage-level-configuration-request-dto';
import { ServiceDuration } from '../interfaces/service-duration';
import { ServiceDurationConfigurationRequestDTO } from '../DTOs/request/service-duration-configuration-request-dto';
import { ReceiverManufacturer } from '../interfaces/receiver-manufacturer';
import { ReceiverManufacturersConfigurationRequestDTO } from '../DTOs/request/receiver-manufacturers-configuration-request-dto';

@Injectable({
    providedIn: 'root'
})

export class DataTranslationService{
    
    constructor() {}

    public translateToAddNewBeamPostRequest(newBeam: string, newBeamLongitude: string): BeamConfigurationRequestDTO{
        let newbeam: BeamIndentification = {
            beamId: newBeam,
            satelliteLongitude: newBeamLongitude
        };
        const addNewBeam: BeamConfigurationRequestDTO = {
            configurationData: newbeam
        };
        return addNewBeam;
    }

    public translateToUpdateBeamPutRequest(selectedBeam: BeamIndentification): BeamConfigurationRequestDTO{
        let tempBeams: BeamIndentification = {
            beamId: selectedBeam.beamId,
            outputOrderNumber: selectedBeam.outputOrderNumber,
            satelliteLongitude: selectedBeam.satelliteLongitude,
            elevationAngle: selectedBeam.elevationAngle
        }
        let modifiedbeams: BeamConfigurationRequestDTO = {
            configurationData: tempBeams
        }
        return modifiedbeams;
    }

    public translateToAddNewCovergaePostRequest(newCoverage: string, noOfBeams: number): CoverageLevelConfigurationRequestDTO{
        let coverage: CoverageLevel = {
            coverageLevelName: newCoverage,
            numberOfBeams: noOfBeams.toString()
        }

        const newCoverageData: CoverageLevelConfigurationRequestDTO = {
            configurationData: coverage
        }
        return newCoverageData;
    }

    public translateToUpdateCovergaePutRequest(updatedCoverage: CoverageLevel): CoverageLevelConfigurationRequestDTO{
        let coverage: CoverageLevel = {
            coverageLevelId: updatedCoverage.coverageLevelId,
            coverageLevelName: updatedCoverage.coverageLevelName,
            numberOfBeams: updatedCoverage.numberOfBeams
        }
        const updatedCoverageData: CoverageLevelConfigurationRequestDTO = {
            configurationData: coverage
        }
        return updatedCoverageData;
    }

    public translateToAddServiceDurationPostRequest(newDuartion: number, newUnits: string): ServiceDurationConfigurationRequestDTO{
        let duration: ServiceDuration = {
            duration: newDuartion,
            durationUnits: newUnits
        }
        const newDurationData: ServiceDurationConfigurationRequestDTO = {
            configurationData: duration
        }
        return newDurationData;
    }

    public translateToUpdateServiceDurationPutRequest(updatedDuration: ServiceDuration): ServiceDurationConfigurationRequestDTO{
        let duration: ServiceDuration = {
            duration: updatedDuration.duration,
            durationUnits: updatedDuration.durationUnits!,
            serviceDurationId: updatedDuration.serviceDurationId
        }
        const newDurationData: ServiceDurationConfigurationRequestDTO = {
            configurationData: duration
        }
        return newDurationData;
    }

    public translateToAddRxManafacturerPostRequest(newManufaName: string, newRxManufaId?: number): ReceiverManufacturersConfigurationRequestDTO{
        let rx: ReceiverManufacturer = {
            manufacturerId: newRxManufaId,
            manufacturerName: newManufaName
        }
        const newRxManufaData: ReceiverManufacturersConfigurationRequestDTO = {
            configurationData: rx
        }
        return newRxManufaData;
    }

    public translateToUpdateRxManufacturerPutRequest(updatedRxManufa: ReceiverManufacturer): ReceiverManufacturersConfigurationRequestDTO{
        let rx: ReceiverManufacturer = {
            manufacturerId: updatedRxManufa.manufacturerId,
            manufacturerName: updatedRxManufa.manufacturerName
        }
        const newRxData: ReceiverManufacturersConfigurationRequestDTO = {
            configurationData: rx
        }
        return newRxData;
    }
}